<template>
    
    <div
        @click.stop.prevent="toggleLike"
        class="heart"
        :class="{ liked : likedClass }"
    >
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28" height="20"
             viewBox="0 0 510 510">
            <path d="M255,489.6l-35.7-35.7C86.7,336.6,0,257.55,0,160.65C0,81.6,61.2,20.4,140.25,20.4c43.35,0,86.7,20.4,114.75,53.55
            C283.05,40.8,326.4,20.4,369.75,20.4C448.8,20.4,510,81.6,510,160.65c0,96.9-86.7,175.95-219.3,293.25L255,489.6z"/>
        </svg>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import axios from 'axios';

    export default {
        name: "LikeButton",
        props: ["recipe_id", "recipe"],
        data() {
            return {
                likedClass: false
            }
        },
        methods: {
            toggleLike() {
                this.likedClass = !this.likedClass;
                if (!this.liked.hasOwnProperty(this.recipe_id)) {
                    if (this.recipe) {
                        this.liked[this.recipe_id] = this.recipe;
                        window.localStorage.setItem("liked",  JSON.stringify(this.liked));
                    } else {
                        this.$store.dispatch("recipe/likeRecipe",  JSON.stringify(this.recipe_id));
                    }
                    this.$store.dispatch("recipe/sendLike",  this.recipe_id);
                } else {
                    delete this.liked[this.recipe_id];
                    window.localStorage.setItem("liked", JSON.stringify(this.liked));
                }
            }
        },
        computed: {
            ...mapState("recipe", ["liked", "currentRecipe"])
        },
        created() {
            this.likedClass = this.liked.hasOwnProperty(this.recipe_id)
        }
    }
</script>
